/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpApprovalGetRequest } from "../funcs/mcpApprovalGetRequest.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ApprovalRequestDetail } from "../models/components/approvalrequestdetail.js";
import {
  GetMcpApprovalRequestRequest,
  GetMcpApprovalRequestSecurity,
} from "../models/operations/getmcpapprovalrequest.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMcpApprovalRequestQueryData = ApprovalRequestDetail;

export function prefetchGetMcpApprovalRequest(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMcpApprovalRequestRequest,
  security?: GetMcpApprovalRequestSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMcpApprovalRequestQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMcpApprovalRequestQuery(
  client$: GramCore,
  request: GetMcpApprovalRequestRequest,
  security?: GetMcpApprovalRequestSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetMcpApprovalRequestQueryData>;
} {
  return {
    queryKey: queryKeyGetMcpApprovalRequest({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function getMcpApprovalRequestQueryFn(
      ctx,
    ): Promise<GetMcpApprovalRequestQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpApprovalGetRequest(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMcpApprovalRequest(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpApproval", "getRequest", parameters];
}
